import { FETCH_COUNTRIES, EDIT_COUNTRY, REMOVE_COUNTRY, ADD_COUNTRY } from "../actionTypes";

export const fetchCountries = countries => ({
    type: FETCH_COUNTRIES,
    countries
});

export const addCountry = country => ({
    type: ADD_COUNTRY,
    country
});

export const deleteCountry = id => ({
    type: REMOVE_COUNTRY,
    id
});

export const editCountry = country => ({
    type: EDIT_COUNTRY,
    country
});
